import initQtyPricingPopover from "components/jiffy/product-card/quantity-price-popover/quantity-price-popover";
import { BulkDiscountSlider } from "components/jiffy/bulk-discount-slider/bulk-discount-slider";
import { track } from "jiffy-analytics";
import { isReplaceShirtPage, isMobile } from "common/utils/browser";
import { on as onEvent } from "common/utils/ui/event";
import initColorSelector from "./color-swatch/color-swatch";
import ColorSwatchHoverClass from "./color-swatch/color-swatch-hover-class";

class ProductCardV3 {
  #$productCards;

  #colorSwatchHoverHandler;

  #colorSwatchClickHandler;

  constructor($productCards) {
    // Desktop: use mouseenter for hover interactions
    this.#colorSwatchHoverHandler = new ColorSwatchHoverClass({
      eventSelector: ".js-color-swatches-link",
      event: "mouseenter"
    });

    // Mobile: use click for color selection (prevents navigation, updates state)
    this.#colorSwatchClickHandler = new ColorSwatchHoverClass({
      eventSelector: ".js-color-swatches-link",
      event: "click"
    });

    if ($productCards && (Array.isArray($productCards) || $productCards instanceof NodeList)) {
      this.#$productCards = Array.from($productCards);
    } else {
      this.#$productCards = [];
    }
  }

  initialize() {
    if (!this.#$productCards || !this.#$productCards.length) return;

    this.#handleReplaceShirtPage();
    ProductCardV3.#initializeColorSwatchMobileClickHandler();

    this.#$productCards.forEach($productCard => {
      ProductCardV3.initProductCardClickHandler($productCard);
      initQtyPricingPopover($productCard);
      initColorSelector($productCard);

      // Initialize bulk discount slider for made products
      const sliderContainer = $productCard.querySelector(".js-bulk-discount-slider");
      if (sliderContainer) {
        // eslint-disable-next-line no-new
        new BulkDiscountSlider(sliderContainer);
      }
    });
  }

  static #initializeColorSwatchMobileClickHandler() {
    if (!isMobile()) return;

    // On mobile, prevent default navigation when clicking color swatches
    // The ColorSwatchHoverClass will handle updating the product card state
    // Using event delegation for better performance
    onEvent(
      "click",
      ".js-product-card-v3 .js-color-swatches-link:not(.js-product-card-link-bare)",
      e => {
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  #handleReplaceShirtPage() {
    if (!isReplaceShirtPage()) return;

    // Add replace parameter to product card URLs
    this.#$productCards.forEach($productCard => {
      const $links = $productCard.querySelectorAll(".js-product-card-link-bare");
      $links.forEach($link => {
        const currentHref = $link.getAttribute("href");
        if (!currentHref) return;

        const urlObj = new URL(currentHref, window.location.origin);
        urlObj.searchParams.set("replace", "true");
        $link.setAttribute("href", urlObj.toString());
      });
    });

    document.querySelectorAll(".js-add-product").forEach($button => {
      $button.textContent = "Select Product";
    });
  }

  static #handleAddProductClick(e, $button, $productCard) {
    e.preventDefault();
    e.stopPropagation();

    const { catalogNumber, compositionId, color } = $productCard.dataset;

    window.parent.postMessage(
      {
        type: "designlabmodal:productadded",
        payload: {
          catalogId: catalogNumber,
          colorName: color,
          compositionId,
          replace: isReplaceShirtPage()
        }
      },
      window.location.origin
    );
  }

  static initProductCardClickHandler($productCard) {
    $productCard.addEventListener("click", e => {
      const { color } = e.target.dataset;
      const $addProductButton = e.target.closest(".js-add-product");

      if (e.target.classList.contains("js-start-designing")) return;

      if ($addProductButton) {
        ProductCardV3.#handleAddProductClick(e, $addProductButton, $productCard);
        return;
      }

      track("product_clicked", {
        ...JSON.parse($productCard.dataset.mixpanelData),
        ...(color ? { color } : {})
      });
    });
  }
}

export default $productCards => new ProductCardV3($productCards).initialize();
